import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Typography } from "@material-ui/core"
import { useSelector } from "react-redux"
import * as confirmationSpielLogic from "../../businesslogic/confirmationSpiel"
import ejs from "ejs/ejs.min.js"
import _ from "lodash"
import moment from "moment"
// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  root: {
    "& label.MuiFormLabel-root": {
      backgroundColor: "#fff",
      marginLeft: "-5px",
      padding: "0 6px",
    },
  },
}))

const BookingConfirmation = () => {
  const classes = useStyles()
  const user = useSelector((state) => state.userInfo.settings.user )
  const quotation = useSelector((state) => state.quotation )
  const bookings = useSelector((state) => state.bookings )
  const locations = useSelector((state) => state.locations.locations )
  const pickup = locations.find(e => e.locationCode === quotation.pickupLocation)
  const pickupDate = moment(quotation.pickupDate, "DD-MM-YYYY").toDate()
  const dropoff = locations.find(e => e.locationCode === quotation.dropoffLocation)
  const dropoffDate = moment(quotation.dropoffDate, "DD-MM-YYYY").toDate()
  const userInfo = useSelector((state) => ({ ...state.userInfo }))
  const confirmationSpielTemplate = _.get(_.find(userInfo.settings.meta, { "key": "confirmationSpielTemplate" }), "value", {})
  const rate = bookings.vehicles.find(v => v.code === _.get(quotation, "customerToReceive", "")) ?? { image: `ZEAUCDAR999.jpg` } 
  const voucher = bookings.vehicles.find(v => v.code === _.get(quotation, "insurerChargedAs", "")) ?? { image: `ZEAUCDAR999.jpg` } 
  const templateData = confirmationSpielLogic.transformSchema({
    ReservationStatus: _.get(bookings, "reservationStatus", ""),
    ReservationNumber: _.get(bookings, "reservationNumber", ""),
    ReservationConfirmed: _.get(bookings, "reservationConfirmed", false),
    ConfirmationNumber: _.get(bookings, "confirmationNumber", ""),
    RateClass: _.get(quotation, "customerToReceive", ""),
    RateImageURL: `https://images.hertz.com/vehicles/220x128/${rate.image}`,
    RateTitle: _.get(quotation, "customerAcrissCategory", ""),
    RateAcriss: _.get(quotation, "customerAcrissCode", ""),
    Options: null,
    ClaimNumber: _.get(quotation, "claimnumber", ""),
    PolicyNumber: _.get(quotation, "policynumber", ""),
    StaffId: user.staffId,
    VoucherClass: _.get(quotation, "customerToReceive", ""),
    VoucherImageURL: `https://images.hertz.com/vehicles/220x128/${voucher.image}`,
    VoucherTitle: _.get(quotation, "insurerAcrissCategory", ""),
    VoucherAcriss: _.get(quotation, "insurerAcrissCode", ""),
    DesiredOptions: "",
    SourceCode: "",
    MainNote: "",
    Notes: [],
    DobOfYoungestDriver: "",
    Pickup: {
      DateTime: pickupDate,
      Month: pickupDate.toLocaleString('default', { month: 'long' }),
      Day: pickupDate.getDate(),
      Year: pickupDate.getFullYear(),
      Time: quotation.pickupTime,
      ...pickup
    },
    DropOff: {
      DateTime: dropoffDate,
      Month: dropoffDate.toLocaleString('default', { month: 'long' }),
      Day: dropoffDate.getDate(),
      Year: dropoffDate.getFullYear(),
      Time: quotation.dropoffTime,
      ...dropoff
    },
    Renter: {
      Title: _.get(quotation, "customer.title", ""),
      FirstName: _.get(quotation, "customer.firstname", ""),
      LastName: _.get(quotation, "customer.lastname", ""),
      LicenseNumber: _.get(quotation, "customer.license", ""),
      LicenseIssuer: _.get(quotation, "customer.issuer", ""),
      LicenseExpiry: _.get(quotation, "customer.expiry", ""),
      Street: _.get(quotation, "customer.address", ""),
      StateOrProvCode: _.get(quotation, "customer.StateOrProvCode", ""),
      PostalCode: _.get(quotation, "customer.postcode", ""),
      CountryCode: _.get(quotation, "customer.country", ""),
      City: _.get(quotation, "customer.city", ""),
      Email: _.get(quotation, "customer.email", ""),
      HomeTelephoneNumber: _.get(quotation, "customer.phone", ""),
      CellTelephoneNumber: _.get(quotation, "customer.mobile", ""),
    },
    AdditionalDriverNotes: {
      FirstName: _.get(quotation, "customer.adfirstname", ""),
      LastName: _.get(quotation, "customer.adlastname", ""),
      Phone: _.get(quotation, "customer.adphone", ""),
      Mobile: _.get(quotation, "customer.admobile", ""),
    }
  }, {locations})

  return (
    <Grid container spacing={0} justify="center" className={classes.root}>
      <Grid container item xs={12} spacing={1} style={{textAlign: "justify"}}>
        <Typography variant="h6">{confirmationSpielTemplate.title}</Typography>
        <br />
        <div dangerouslySetInnerHTML={({__html: ejs.render(confirmationSpielTemplate.body, templateData)})} />
      </Grid>
    </Grid>
  )
}

export default BookingConfirmation
